import React, { useEffect, useState } from "react";
import StickyTitle from '../components/StickyTitle'
import ReactToPrint from "react-to-print";
import {
    InputLabel,
    FormControl,
    Button,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import companylogo from "../../assets/company.png"

import Select from 'react-select'

const SalesReportPage = () => {

    const [invoicedata, setInvoicedata] = useState();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [filteredInvoiceData, setFilteredInvoiceData] = useState();
    const [category, setCategory] = useState(null)
    const [categoryData, setCategoryData] = useState(null)
    const [client, setClient] = useState(null)
    const [clientData, setClientData] = useState([])
    const [salesman, setSalesman] = useState(null)
    const [salesmanData, setSalesmanData] = useState([])

    //Credit Cash
    const [filteredInvoiceDataCash, setFilteredInvoiceDataCash] = useState('')
    const [filteredInvoiceDataCredit, setFilteredInvoiceDataCredit] = useState('')

    const [selectedValue, setSelectedValue] = useState('other'); // Initialize the state with the default value

    const handleRadioChange = (event) => {
        setSelectedValue(event.target.value); // Update the state with the selected value
    };


    const componentRef = React.createRef();

    useEffect(() => {
        const fetchInvoiceData = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/invoices/all_invoices`
                );
                const responseData = await response.json();
                if (responseData) {
                    setInvoicedata(responseData.invoice)
                }
            } catch (error) {
                console.log(error.message);
            }
        };

        fetchInvoiceData();


        // fetch category

        const fetchCategory = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/category/all_categories`);
                const responseData = await response.json();
                if (responseData) {
                    const temp = responseData.categories?.map((cat)=>
                    ({value:cat.id, label:`${cat.categoryname} ID: ${cat.id}`})
                    )
                    setCategoryData(temp)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchCategory();

        // fetch clients

        const fetchClients = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/clients/all_clients`);
                const responseData = await response.json();
                if (responseData) {
                    const temp = responseData.client?.map((client)=>
                    ({value:client.id, label:`${client.companyname} ID: ${client.id}`})
                    )
                    setClientData(temp)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchClients();

        // fetch salesmen

        const fetchSalesmen = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/salesman/all_salesmen`
                );
                const responseData = await response.json();
                if (responseData) {
                    const temp = responseData.salesmen?.map((salesman)=>
                    ({value:salesman.id, label:`${salesman.fullname} ID: ${salesman.id}`})
                    )
                    setSalesmanData(temp)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchSalesmen();

    }, []);

    const [splitData, setSplitData] = useState(null)

    useEffect(() => {
        let filteredData = invoicedata;

        const newData = [];

        if (selectedValue === "monthly" || selectedValue === "yearly") {
            // Iterate over the original data
            invoicedata?.forEach(sale => {
                const issueDate = new Date(sale.issuedate);
                const month = issueDate.getMonth() + 1; // Get the month (1-indexed)
                const year = issueDate.getFullYear(); // Get the year
                
                const monthName = new Date(year, month - 1).toLocaleString('default', { month: 'long' });
        
                if (selectedValue === "monthly") {
                    // Create unique keys for month and year
                    const monthKey = `${year}-${monthName}`;
                    const existingMonthData = newData.find(item => item.issuemonth === monthKey);
        
                    if (!existingMonthData) {
                        newData.push({
                            issuemonth: monthKey,
                            total: parseFloat(sale.total)
                        });
                    } else {
                        existingMonthData.total += parseFloat(sale.total);
                    }
                }
        
                if (selectedValue === "yearly") {
                    const yearKey = year.toString();
                    const existingYearData = newData.find(item => item.issueyear === yearKey);
        
                    if (!existingYearData) {
                        newData.push({
                            issueyear: yearKey,
                            total: parseFloat(sale.total)
                        });
                    } else {
                        existingYearData.total += parseFloat(sale.total);
                    }
                }
            });
            
            console.log(newData);
            setSplitData(newData);
        }
        
        if (fromDate && toDate) {
            filteredData = filteredData.filter(payment => payment.issuedate >= fromDate && payment.issuedate <= toDate);
        }

        if(category) {
            filteredData = filteredData.filter(payment => payment.categoryId === category.value);
        }

        if(salesman) {
            
            filteredData = filteredData.filter(payment => payment.salesmanid == salesman.value);
        }

        if(client) {
            filteredData = filteredData.filter(payment => payment.clientid == client.value);
        }

        setFilteredInvoiceData(filteredData)

        const temp1 = filteredData?.filter((invoice)=>invoice.paymentType==="Credit")
        setFilteredInvoiceDataCredit(temp1)

        const temp2 = filteredData?.filter((invoice)=>invoice.paymentType==="Cash")
        setFilteredInvoiceDataCash(temp2)

    }, [invoicedata, fromDate, toDate, category, salesman, client,selectedValue]);

    const calculateTotalPayments = (payments) => {
        return payments && payments?.reduce((total, payment) => total + parseInt(payment.total), 0);
    };

    return (
        <>
            <StickyTitle no_button={true} title="Sales Reports" />
            <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>

                <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
                    <div className='text-2xl ml-2 font-bold font-poppins'>Sales Report</div>
                </div>
                <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
                    <section>
                        <div className="bg-white p-5 rounded shadow">
                            <div className="flex flex-col justify-center">
                                <Button onClick={() => {
                                    setFromDate('')
                                    setFromDate('')
                                    setCategory('')
                                    setSalesman('')
                                    setClient('')
                                    setSelectedValue('other')
                                }} variant="contained" disableElevation>
                                    Clear Filters
                                </Button>

                                <div className="mt-5">
                                <FormControl>
                                <FormLabel id="demo-radio-buttons-group-label">Sales View</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        value={selectedValue} // Set the value of the RadioGroup to the state variable
                                        onChange={handleRadioChange} // Handle changes in the selected value
                                        name="radio-buttons-group"
                                    >
                                        <FormControlLabel value="monthly" control={<Radio />} label="Monthly" />
                                        <FormControlLabel value="yearly" control={<Radio />} label="Yearly" />
                                        <FormControlLabel value="other" control={<Radio />} label="All" />
                                    </RadioGroup>
                                </FormControl>
                                </div>

                                {selectedValue==="other"&&(
                                <>
                                    <div className="my-5">
                                <InputLabel>Filter Category</InputLabel>
                                    <Select
                                        value={category}
                                        onChange={(selectedOption) => setCategory(selectedOption)}
                                        options = {categoryData}
                                        isClearable={true}
                                    />  
                                </div>

                                <div className="my-5">
                                <InputLabel>Filter Client</InputLabel>
                                    <Select
                                        value={client}
                                        onChange={(selectedOption) => setClient(selectedOption)}
                                        options = {clientData}
                                        isClearable={true}
                                    />  
                                </div>

                                <div className="my-5">
                                <InputLabel>Filter Salesman</InputLabel>
                                    <Select
                                        value={salesman}
                                        onChange={(selectedOption) => setSalesman(selectedOption)}
                                        options = {salesmanData}
                                        isClearable={true}
                                    />  
                                </div>
                               
                                <InputLabel>From Date</InputLabel>
                                <FormControl>
                                    <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                                </FormControl>
                                <InputLabel>To Date</InputLabel>
                                <FormControl>
                                    <input type="date" onChange={(e) => setToDate(e.target.value)} />
                                </FormControl>
                                </>
                            )}
        
                                <ReactToPrint
                                    trigger={() => (
                                        <button className="bg-green-500 mt-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                            Generate Report
                                        </button>
                                    )}
                                    content={() => componentRef.current}
                                />
                            </div>
                        </div>
                    </section>

                    <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                        <ReactToPrint
                            trigger={() => (
                                <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                    Print / Download
                                </button>
                            )}
                            content={() => componentRef.current}
                        />
                        <div
                            ref={componentRef}
                            className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative"
                        >
                            <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                <div>

                                    <img  src={companylogo} alt="logo" />
                                </div>
                            </div>
                            <article className=" py-2 text-center text-base text-black border-t border-black uppercase w-full font-bold">
                                <p>Sales Report</p>
                            </article>

                            {selectedValue==="other"?(
                            <>
                                <table width="100%" className="mb-10">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                        <td className="font-bold">Invoice Number</td>
                                        <td className="font-bold">Client Name</td>
                                        <td className="font-bold">Salesman</td>
                                        <td className="font-bold">Issue Date</td>
                                        <td className="font-bold">Total</td>
                                    </tr>
                                </thead>
                                <InputLabel className=" ml-2 mt-2 italic text-base">Credit Sales</InputLabel>
                                <tbody className=" border-b border-t border-gray-400">
                                    {filteredInvoiceDataCredit && filteredInvoiceDataCredit?.map((invoice) => (
                                        <tr className=" text-center h-10" key={invoice.id}>
                                            <td>{invoice.invoicenumber}</td>
                                            <td>{invoice.client}</td>
                                            <td>{invoice.salesman}</td>
                                            <td>{invoice.issuedate}</td>
                                            <td>{invoice.total}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <InputLabel className=" ml-2 mt-2 italic text-base">Cash Sales</InputLabel>
                                <tbody className=" border-t border-gray-400">
                                    {filteredInvoiceDataCash && filteredInvoiceDataCash?.map((invoice) => (
                                        <tr className=" text-center h-10" key={invoice.id}>
                                            <td>{invoice.invoicenumber}</td>
                                            <td>{invoice.client}</td>
                                            <td>{invoice.salesman}</td>
                                            <td>{invoice.issuedate}</td>
                                            <td>{invoice.total}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <td className=" font-bold text-md text-center" colSpan={2}>
                                    Total Sales: QAR {Math.round(calculateTotalPayments(filteredInvoiceData)).toLocaleString()}
                                </td>
                            </tr>
                            </>
                            
                            ):(

                                <>
                                <table width="100%" className="mb-10">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                        <td className="font-bold">Month/Year</td>
                                        <td className="font-bold">Total Sales</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {splitData && splitData?.map((data,index) => (
                                        <tr className=" text-center h-10" key={index}>
                                            <td>{data.issuemonth?data.issuemonth:data.issueyear}</td>
                                            <td>{data.total}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <td className=" font-bold text-md text-center" colSpan={2}>
                                    Total Sales: QAR {Math.round(calculateTotalPayments(filteredInvoiceData)).toLocaleString()}
                                </td>
                            </tr>
                            </>
                            )}
                            <tr className=" text-center h-10 font-bold mt-2">
                                <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                                    Accountant
                                </td>
                            </tr>


                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default SalesReportPage